import { Configuration, LogLevel, PublicClientApplication } from '@azure/msal-browser';

function getRedirectUrl(): string {
  return `${location.origin}/login`;
}

export const msalConfig: Configuration = {
  auth: {
    clientId: process.env.VUE_APP_CLIENT_ID ?? '',
    authority: 'https://login.microsoftonline.com/common/',
    redirectUri: getRedirectUrl(),
    postLogoutRedirectUri: getRedirectUrl(),
  },
  cache: {
    cacheLocation: 'localStorage',
  },
  system: {
    loggerOptions: {
      loggerCallback: (level: LogLevel, message: string, containsPii: boolean): void => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            return;
          case LogLevel.Info:
            console.info(message);
            return;
          case LogLevel.Verbose:
            console.debug(message);
            return;
          case LogLevel.Warning:
            console.warn(message);
            return;
          default:
            return;
        }
      },
      logLevel: LogLevel.Verbose,
    },
  },
};

export const msalInstance = new PublicClientApplication(msalConfig);

// Add here scopes for id token to be used at MS Identity Platform endpoints.
export const loginRequest = {
  scopes: ['User.Read'],
};

// Add here the endpoints for MS Graph API services you would like to use.
export const graphConfig = {
  graphMeEndpoint: 'https://graph.microsoft.com/v1.0/me',
};
